import { InnerContentItem, OuterContentItem } from "@certn/cascadia-react";
import { ArrayControlProps } from "@jsonforms/core";
import { useTranslation } from "react-i18next";

import { formatDocumentType } from "./utils";

interface IdentityDocumentItem {
  document_type?: string;
  document_number?: string;
}

export function IdentityDocumentFilesSummaryControl(props: ArrayControlProps) {
  const { t } = useTranslation();
  const items = (props.data as IdentityDocumentItem[]) ?? [];

  return (
    <>
      {items.map((item, index) => (
        <OuterContentItem
          key={index}
          title={
            item.document_type
              ? formatDocumentType(item.document_type)
              : t("Identity document")
          }
          testID={`identity-document-summary-${index + 1}`}
        >
          {item.document_number && (
            <InnerContentItem
              label={t("Document number")}
              testID={`identity-document-summary-document-number-${index + 1}`}
            >
              {item.document_number}
            </InnerContentItem>
          )}
        </OuterContentItem>
      ))}
    </>
  );
}
